import { message } from "./message";
import { packages } from "./packages";
import { whatsapp } from "./whatsapp";

export const communication = {
	title: "Mensajes",
	label: "Mensajes enviados",
	export: "Exportar a Excel",
	new: "Nuevo mensaje",
	status: {
		sent: "enviado",
		canceled: "cancelado",
		notSent: "no enviado",
		scheduled: "programado",
		error: "error",
		delivered: "entregado",
		optout: "optout",
		sending: "enviando",
	},
	columns: {
		message: "Mensaje",
		place: "Local",
		campaign: "Campaña",
		channel: "Canal",
		date: "Fecha y hora",
		status: "Estado",
		impactedCustomers: "Clientes impactados",
	},
	at: "a las",
	actions: {
		list: {
			sent: "Ver informe de envío",
			schedule: {
				editAddressees: "Editar destinatarios",
				editMessage: "Editar contenido del mensaje",
				cancelShipping: "Cancelar envío",
				hitchCampaign: "Vincular envío a campaña",
			},
			canceled: "Ver informe del mensaje",
		},
		cancelModal: {
			close: "Cerrar",
			cancel: "Cancelar envío",
			text: "¿Desea cancelar el envío del mensaje programado para ",
			clients: "clientes el día",
			at: "a las",
			confirm: "Al cancelar el envío, su saldo volverá a su cuenta en unas horas.",
		},
		campaignCategoryModal: {
			title: "Vincular envío a campaña",
			tooltipMessage:
				"OPCIONAL: Vincule este envío a una campaña para facilitar el análisis del rendimiento de múltiples envíos juntos.",
			placeholder: "Seleccione una campaña",
			text: "Seleccionar campaña",
			textButtonConfirm: "Confirmar selección",
			successMessage: "Campaña vinculada al mensaje",
		},
	},
	message,
	packages,
	whatsapp,
	warningCard: {
		title: "Pago",
		label: "El valor de {{value}} se agregará al pago del cobro mensual de Zig.",
	},
	modalChannel: {
		title: "Canal de comunicación",
		channel: {
			sms: {
				title: "SMS",
				description:
					"Seleccione un local, filtre los clientes y envíe mensajes de texto estándar",
			},
			whatsapp: {
				title: "WhatsApp",
				description:
					"Seleccione un local, filtre los clientes y envíe mensajes de WhatsApp",
			},
			email: {
				title: "E-mail",
				description:
					"Seleccione un local, filtre los clientes y envíe correos electrónicos personalizados",
			},
		},
		tags: {
			new: "Nuevo",
			comingSoon: "Próximamente",
		},
	},
	permissionDenied: "Ningún local con permiso para gestionar mensajes de WhatsApp",
};
